import { renderMoney } from "@/service/ecommerce/currency";
import { trans } from "@/service/i18n/i18n";
import { BuyButton } from "@/components/ecommerce/buy-button";
import { ButtonVariant } from "@/components/ui/button";

export const CourseCardCta = ({
  product,
  name,
  preorder,
  variant,
}: {
  product: ProductPriceOneVariantVM;
  name: string;
  preorder: boolean;
  variant: ButtonVariant;
}) => {
  const buyCtaText = preorder
    ? "ecommerce.buy_preorder_for"
    : "ecommerce.buy_for";

  const actualPrice =
    product.promotionPrice != product.price
      ? product.promotionPrice
      : product.price;

  return (
    <BuyButton
      product={product}
      text={`${trans(buyCtaText)} ${renderMoney(actualPrice)}`}
      name={name}
      category={"Kurs"}
      instantMoveToCart={true}
      variant={variant}
    />
  );
};
